<template>
  <div>
    <BaseDivider grey class="mt-8 mb-4" />
    <div class="d-flex justify-center my-4">
      <router-link
        :to="{ name: 'Register' }"
        class="link_signup"
        v-text="$t('wallet.signIn.signup')"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "WalletHasToRegister",
};
</script>
<style scoped>
.link_signup {
  text-decoration: none;
}
.link_signup:hover {
  transition: all 0.75s ease;
  color: var(--v-walletAccent-base);
  text-decoration: underline;
}
</style>
